<template>
  <section id="admin-filter">
    <h4>Role filter</h4>
    <div class="form-group">
      <label for="role-code" class="form-label">Code</label>
      <input type="text" class="form-control" id="role-code" v-model="entity.code"/>
    </div>
    <div class="form-group">
      <label for="role-desc" class="form-label">Name</label>
      <input type="text" class="form-control" id="role-desc" v-model="entity.name"/>
    </div>
    <div class="text-center">
      <div class="btn btn-primary sq"  @click="emitSearch">
        Search
      </div>
      <div class="btn btn-danger sq"  @click="close">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import FilterMixin from '../../mixins/FilterMixin'
  export default {
    name: 'RoleFilter',
    mixins: [ FilterMixin ],
    data () {
      return {
        entity: {
          code: '',
          name: ''
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// RoleFilter.vue?f7e4d6ea